module.exports = __webpack_public_path__ + "static/media/91230016.4a36a876.jpg";